import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ellipsis-vertical-sharp",
  "use": "icon-ellipsis-vertical-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-ellipsis-vertical-sharp\"><title>Ellipsis Vertical</title><circle cx=\"256\" cy=\"256\" r=\"48\" /><circle cx=\"256\" cy=\"416\" r=\"48\" /><circle cx=\"256\" cy=\"96\" r=\"48\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol